import React from 'react';
import { OptionLayoutsSkeleton } from '../Skeleton/OptionLayouts.Skeleton';
import { OptionSizesSkeleton } from '../Skeleton/OptionSizes.Skeleton';
import { OptionColorsSkeleton } from '../Skeleton/OptionColors.Skeleton';
import { AddButtonWrapperSkeleton } from '../Skeleton/AddButtonWrapper.Skeleton';
import { MEDIA_BREAKPOINTS } from '../../../../../constants/MEDIA_BREAKPOINTS';
export const CustomHexagonSkeleton = () => (React.createElement("div", null,
    React.createElement(OptionLayoutsSkeleton, { nbItems: 7 }),
    React.createElement(OptionSizesSkeleton, { nbItems: 2 }),
    React.createElement(OptionColorsSkeleton, { nbItems: 1 }),
    MEDIA_BREAKPOINTS.LG_UP.matches &&
        React.createElement(AddButtonWrapperSkeleton, null)));
